import React from 'react';
import { Redirect } from 'react-router-dom';
import WorkOrderTable from '../WorkOrderTable';
import { TrackedWorkOrderTableEmptyState } from '../WorkOrderTable/emptyState/WorkOrderTableEmptyState';
import { BUYER_WO_FILTERS_ORDER } from '../../utils/WorkOrderUtils';
import { FILTER_CONFIG_NAMES } from '../../utils/DataConstants';
import { isWorkOrderLabelsTrackEnabled } from '../../data/workOrderStarLabels';

const STARRED_TAB_FILTERS = BUYER_WO_FILTERS_ORDER.filter(
	(filterName) => filterName !== FILTER_CONFIG_NAMES.STARRED
);

export default function WorkOrdersStarredIndexPage() {
	// The Tracked view is gated behind workorder-labels-track and hidden from tabs/pickers when off;
	// guard the direct route too so /workOrders/overview/starred can't expose it by URL.
	if (!isWorkOrderLabelsTrackEnabled()) {
		return <Redirect to="/buyer/workOrders/overview/active" />;
	}
	return (
		<WorkOrderTable
			handleQueryParams
			preAppliedFilters={{ starredByCurrentUser: true }}
			filterConfig={{ filters: STARRED_TAB_FILTERS }}
			renderEmptyState={TrackedWorkOrderTableEmptyState}
		/>
	);
}
